import React from 'react';
import { Loader } from '@mantine/core';
import { Button } from '../../styledComponents';
import styles from '../../../styles/logpost.module.css';

interface Props {
  onClose: () => any;
  isLoading: boolean;
  onSubmit: () => any;
}

function AddLogPostBottomComponent({ onClose, isLoading, onSubmit }: Props) {
  return (
    <div className={styles.addLogPostLinkButtonGroup}>
      <Button
        bgColor="transparent"
        color="var(--dark-grey)"
        style={{ border: '1px solid var(--light-grey)', flex: 1 }}
        type="button"
        onClick={() => onClose()}
      >
        Cancel
      </Button>
      <Button
        disabled={isLoading}
        type="button"
        onClick={() => onSubmit()}
        bgColor="var(--purple-p-400)"
        style={{ flex: 1 }}
      >
        {isLoading && <Loader color="white" size="xs" />}
        Save
      </Button>
    </div>
  );
}

export default AddLogPostBottomComponent;
